import React from 'react'
const RolesContext = React.createContext({})
export const RolesProvider = RolesContext.Provider
export default RolesContext